import { Button } from "@shltelemedicine/shl-ui-lib";
import Card from "../../components/Shared/Card/Card";
import styles from "./LimitedPage.module.css";
import heartImage from "@shltelemedicine/shl-ui-lib/dist/assets/brand/heart.svg";

import {
  MainContextActionType,
  useMainContext,
} from "../../context/MainContext";
import { FormattedMessage } from "react-intl";

const LimitedPage = () => {
  const { dispatch } = useMainContext();

  const toggleSupportHandler = () => {
    dispatch({
      type: MainContextActionType.SET_SHOW_SUPPORT,
      payload: { show: true },
    });
  };

  return (
    <div className={`${styles.wrapper} h-100 w-100`}>
      <header className={`${styles.header} p-3`}>
        <p className="mb-0 prim-color">
          <strong>
            <FormattedMessage
              id="LIMITED.HEADER_TITLE"
              defaultMessage="Welcome to smartheart"
            />
            ,
          </strong>
        </p>
      </header>
      <Card className={`${styles.card} p-4 muted-color app-shadow`}>
        <div className="d-flex">
          <div className={styles.imgWrapper}>
            <img src={heartImage} alt="" className="img-fluid" />
          </div>
          <div className="mx-2"></div>
          <div className="px-4">
            <h4 className="font-weight-bold">
              <FormattedMessage
                id="LIMITED.BODY_TITLE"
                defaultMessage="Your authorization is limited"
              />
              .
            </h4>
            <p>
              <strong>
                <FormattedMessage
                  id="LIMITED.BODY_TEXT"
                  defaultMessage="For additional information you may"
                />

                <span className="d-inline-block mx-1">
                  <Button
                    variant="link"
                    className={`${styles.contactBtn} p-0 text-decoration-link font-weight-bold`}
                    size="sm"
                    onClick={toggleSupportHandler}
                  >
                    <FormattedMessage
                      id="SUPPORT.TITLE"
                      defaultMessage="Contact Customer service"
                    />
                    .
                  </Button>
                </span>
              </strong>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default LimitedPage;
